import React from 'react'
import AceCodeEditorContainer from '../../../../Components/Miscellaneous/Editor/AceCodeEditor'

export default function AceCodeEditor() {
  return (
    <div className='page-body'>
        <AceCodeEditorContainer/>
    </div>
  )
}
